import { anythingToString } from '@hawkins/helpers';
export var DROPDOWN_ON_CREATE_OPTION_NULL = Symbol('DROPDOWN_ON_CREATE_OPTION_NULL');
export var A11Y_HAWKINS_DROPDOWN_DESCRIBES_ID = 'hawkins-dropdown-description';
export var A11Y_HAWKINS_DROPDOWN_LIST_ID = 'hawkins-dropdown-list';
export var A11Y_HAWKINS_DROPDOWN_TRIGGER_LABEL_ID = 'hawkins-dropdown-button-trigger-label';
export var dropdownDisplayName = 'Dropdown';
export var creatableFooterDataSelector = 'data-hawkinsdropdown-creatablefooter';
/**
 * The component type name used to specify the composable element for the group
 * header in the dropdown list
 */
export var DROPDOWN_ELEMENT_GROUP_HEADER_TYPE = 'DropdownListGroupHeader';
/**
 * The time (in ms) that will take for the onBlur event to propagate outside the
 * component
 * Note: the event is triggered immediately internally, we just delay the propagation
 */
export var ONBLUR_DELAY = 300;
/**
 * Default dropdown min list width
 */
export var DEFAULT_LIST_MIN_WIDTH = '200px';
export var DropdownTestIds = {
    CLEAR_BUTTON: 'hawkins-dropdown-clear-button',
    CONTAINER: 'hawkins-dropdown-container',
    INPUT: 'hawkins-dropdown-input',
    SELECTED_CHIP: 'hawkins-dropdown-selected-chip',
    SELECTED_HIDDEN_COUNT: 'hawkins-dropdown-selected-hidden-count',
    SELECTED_VALUE: 'hawkins-dropdown-selected-value',
};
export var GET_DEFAULT_FILTER_OPTIONS = function (currentOptions, getOptionLabel, getOptionValue) {
    return function (query) {
        if (!currentOptions) {
            throw new Error('Unable to perform default filter on the options provided to <Dropdown />');
        }
        var lowerQuery = query.toLowerCase();
        if (!lowerQuery)
            return currentOptions;
        return currentOptions.filter(function (opt) {
            return (getOptionLabel(opt).toLowerCase().includes(lowerQuery) ||
                anythingToString(getOptionValue(opt)).toLowerCase().includes(lowerQuery));
        });
    };
};
/**
 * Given a rawValue, constructs a default DropdownOption from it.
 *
 * Note: be mindful that the returned DropdownOption is forcefully typecast, which can cause issues in
 * cases where the consumer's rawValue and option.value types differ. In that case, only when the
 * consumer explicitly provides Option and RawValue generic types to Dropdown will this be technically
 * completely type safe
 */
export var DEFAULT_ON_CREATE_OPTION_FROM_RAW_VALUE = function (rawValue) {
    return ({
        label: anythingToString(rawValue),
        value: rawValue,
    });
};
export var DEFAULT_SHOULD_SHOW_CREATABLE_FOOTER = function (query, options) { return Boolean(query && !(options === null || options === void 0 ? void 0 : options.some(function (o) { return o.label === query; }))); };
export var DEFAULT_GET_OPTION_DISABLED = function (option) {
    return (option === null || option === void 0 ? void 0 : option.disabled) || false;
};
export var DEFAULT_GET_OPTION_LABEL = function (option) {
    return (option === null || option === void 0 ? void 0 : option.label) || '';
};
export var DEFAULT_GET_OPTION_SUBTITLE = function (option) {
    return option === null || option === void 0 ? void 0 : option.subtitle;
};
/**
 * Given a DropdownOption, computes the default equivalent of the rawValue from it (option.value).
 *
 * Note: be mindful that the returned DropdownOption is forcefully typecast, which can cause issues in
 * cases where the consumer's rawValue and option.value types differ. In that case, only when the
 * consumer explicitly provides Option and RawValue generic types to Dropdown will this be technically
 * completely type safe
 */
export var DEFAULT_GET_OPTION_VALUE = function (option) {
    return option.value;
};
export var DROPDOWN_LIST_GROUP_HEADER_CLASS = 'hawkins-dropdown-list-group-header';
/**
 * Default maxHeight of the Dropdown Options list that displays the dropdown's options
 */
export var DROPDOWN_LIST_WRAPPER_HEIGHT = 400;
/**
 * Default height of a standard dropdown option
 */
export var DEFAULT_ITEM_HEIGHT = 40;
/**
 * Default height of a compact dropdown option
 */
export var DEFAULT_ITEM_HEIGHT_COMPACT = 34;
/**
 * Default height of a dropdown's grouped header
 */
export var DEFAULT_GROUPBY_HEADER_LABEL_HEIGHT = 34;
/**
 * Default height of a dropdown's standard option that contains a subtitle
 */
export var DEFAULT_ITEM_HEIGHT_WITH_SUBTITLE = 56;
/**
 * Default height of a dropdown's compact option that contains a subtitle
 */
export var DEFAULT_ITEM_HEIGHT_WITH_SUBTITLE_COMPACT = 50;
/*
 * Statically created array. Useful for providing a fallback value that won't fail
 * referential equality checks
 */
export var STABLE_EMPTY_ARRAY = [];
